// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B_ZEt6zJzIFeylQsaiIx{border-top:1px solid var(--background-neutral-default)}`, "",{"version":3,"sources":["webpack://./src/entities/Ampersand/ui/AmpersandConnectButton/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,sDAAA","sourcesContent":[".wrap {\n  border-top: 1px solid var(--background-neutral-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `B_ZEt6zJzIFeylQsaiIx`
};
export default ___CSS_LOADER_EXPORT___;
